module.exports = {
   extends: [
       '/',
       'templates',
       'customers',
       'projects',
       'orderHints',
   ]
}